import React from 'react';
import { HotFilterGroupConfiguration, HotFilterTypes } from '@config/catalog/hotfilter-group-configurations';
import CatalogHotfilterCheckboxList from '@components/catalog/catalog-hotfilters/catalog-hotfilter-list/catalog-hotfilter-checkbox-list/catalog-hotfilter-checkbox-list';
import CatalogPriceHotfilter from '@components/catalog/catalog-hotfilters/catalog-price-hotfilter/catalog-price-hotfilter';
import CatalogSizeHotfilter from '@components/catalog/catalog-hotfilters/catalog-size-hotfilter/catalog-size-hotfilter';
import CatalogCategoryHotfilter from '@components/catalog/catalog-hotfilters/catalog-category-hotfilter/catalog-category-hotfilter';
import CatalogMaterialHotfilter from '@components/catalog/catalog-hotfilters/catalog-material-hotfilter/catalog-material-hotfilter';

interface CatalogHotfilterListProps {
  filterGroup: HotFilterGroupConfiguration;
}

const CatalogHotfilterList: React.FC<CatalogHotfilterListProps> = ({ filterGroup }) => {
  if (filterGroup.type === HotFilterTypes.CATEGORY) {
    return <CatalogCategoryHotfilter />;
  }

  if (filterGroup.type === HotFilterTypes.MATERIAL) {
    return <CatalogMaterialHotfilter />;
  }

  if (filterGroup.type === HotFilterTypes.ITEM) {
    return <CatalogHotfilterCheckboxList filterGroup={filterGroup} />;
  }

  if (filterGroup.type === HotFilterTypes.PRICE) {
    return <CatalogPriceHotfilter />;
  }

  if (filterGroup.type === HotFilterTypes.SIZE) {
    return <CatalogSizeHotfilter />;
  }

  return null;
};

export default CatalogHotfilterList;
